// extracted by mini-css-extract-plugin
export default {"box":"SplitHourMinuteTimeInput_box__vQ+qa","part":"SplitHourMinuteTimeInput_part__R9Ol8","colon":"SplitHourMinuteTimeInput_colon__XLBU-"};